export default "/_next/static/sounds/KEYPAD_BUTTON_4-f1bf90df830bd2620b95697c5ed90347.mp3";